import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://www.hadleyswello.com';

const pageMetadata = {
  '/': {
    title:
      'Hadley Swello - Senior Software Engineer | Full Stack Developer Portfolio | Open to Contract Work',
    description:
      'Senior Software Engineer open to remote contract work. Full-stack developer specializing in Ruby on Rails, React, and modern web technologies. Remote-only, available for contract opportunities.',
    keywords:
      'Hadley Swello, Software Engineer, Full Stack Developer, Ruby on Rails, React Developer, Portfolio, Senior Software Engineer, Remote Developer, Contract Software Engineer, Available for Work, Hire Software Engineer, Remote Only Developer',
    ogImage: `${BASE_URL}/profile-picture.jpg`,
  },
  '/about': {
    title:
      'About Hadley Swello - Senior Software Engineer | Open to Contract Work',
    description:
      'Get to know Hadley Swello, a Senior Software Engineer open to remote contract work. Background in teaching brings patience, clear communication, and a love for building maintainable code.',
    keywords:
      'About Hadley Swello, Software Engineer, Full Stack Developer, Ruby on Rails, React, Developer Background, Remote Contract Work, Senior Software Engineer',
    ogImage: `${BASE_URL}/profile-picture.jpg`,
  },
  '/experience': {
    title: 'Professional Experience - Hadley Swello | Senior Software Engineer',
    description:
      "Explore Hadley Swello's career as a Senior Software Engineer. Experience with Ruby on Rails, React, PostgreSQL, AWS, and modern web development. Open to remote contract work opportunities.",
    keywords:
      'Hadley Swello Experience, Software Engineer Resume, Ruby on Rails Developer, React Developer, Full Stack Developer Experience, Senior Software Engineer, Remote Contract Work, Available for Hire',
    ogImage: `${BASE_URL}/profile-picture.jpg`,
  },
  '/endorsements': {
    title: 'Endorsements - Hadley Swello',
    description:
      'What colleagues say about working with Hadley Swello. Real testimonials from team members and collaborators.',
    keywords:
      'Hadley Swello Reviews, Software Engineer Endorsements, Developer Testimonials',
    ogImage: `${BASE_URL}/profile-picture.jpg`,
  },
  '/widgets': {
    title: 'Free Hangman Game Online - Play Hangman Word Game | Hadley Swello',
    description:
      'Play a free hangman game online! Interactive word guessing game with multiple categories. No downloads required. Built by Senior Software Engineer Hadley Swello.',
    keywords:
      'free hangman game, play hangman online, hangman word game, free word guessing game, online hangman, hangman puzzle, word game, hangman game free, interactive hangman, Hadley Swello',
    ogImage: `${BASE_URL}/profile-picture.jpg`,
  },
  '/contact': {
    title:
      'Contact Hadley Swello - Senior Software Engineer | Open to Contract Work',
    description:
      'Contact Hadley Swello for remote contract work opportunities. Senior Software Engineer specializing in Ruby on Rails, React, and modern web technologies. Remote-only developer available for contract projects.',
    keywords:
      'Contact Hadley Swello, Hire Software Engineer, Remote Developer, Contract Work, Software Engineer Available, Senior Software Engineer Contact, Remote Contract Developer',
    ogImage: `${BASE_URL}/profile-picture.jpg`,
  },
};

function SEOHead() {
  const location = useLocation();

  useEffect(() => {
    // Get metadata for current path
    const metadata = pageMetadata[location.pathname] || pageMetadata['/'];

    // Update document title
    document.title = metadata.title;

    // Update or create meta tags
    const updateMetaTag = (name, content, attribute = 'name') => {
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    // Update description
    updateMetaTag('description', metadata.description);

    // Update keywords
    updateMetaTag('keywords', metadata.keywords);

    // Update Open Graph tags
    updateMetaTag('og:title', metadata.title, 'property');
    updateMetaTag('og:description', metadata.description, 'property');
    updateMetaTag('og:image', metadata.ogImage, 'property');
    updateMetaTag('og:url', `${BASE_URL}${location.pathname}`, 'property');
    updateMetaTag('og:type', 'website', 'property');
    updateMetaTag('og:site_name', 'Hadley Swello', 'property');

    // Twitter Card tags removed - not using Twitter

    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${BASE_URL}${location.pathname}`);
  }, [location.pathname]);

  return null;
}

export default SEOHead;
